// import React, { useState, useEffect } from 'react';
// import AnnualHeadStats from '../components/annualView/annualHeadStats';
// import AnnualViewTabs from '../components/annualView/annualViewTabs';
// import { annualViewTabs as AnnualViewTabsStyle } from '../css/styles/componentStyles';
// const AnnualView = () => {
//   const [activeTab, setActiveTab] = useState('annual');

//   return (
//     <>
//       <div style={AnnualViewTabsStyle.container}>
//         <div style={AnnualViewTabsStyle.tabContainer}>
//           <AnnualViewTabs activeTab={activeTab} setActiveTab={setActiveTab} />
//           <div style={AnnualViewTabsStyle.contentContainer}>
//             <div style={{ ...AnnualViewTabsStyle.content, transform: `translateX(${activeTab === 'annual' ? '0%' : '-50%'})`, }}>
//               <div style={AnnualViewTabsStyle.panel}>
//                 <AnnualHeadStats />
//                 <AnnualHeadStats />
//                 <AnnualHeadStats />
//               </div>
//               <div style={AnnualViewTabsStyle.panel}>
//                 <AnnualHeadStats />
//               </div>


//             </div>
//           </div>

//         </div>
//       </div>
//     </>

//   );
// };

// export default AnnualView;

import React, { useState, useEffect } from 'react';
import AnnualHeadStats from '../components/annualView/annualHeadStats';
import AnnualViewTabs from '../components/annualView/annualViewTabs';
import { annualViewTabs as AnnualViewTabsStyle } from '../css/styles/componentStyles';
import FinancialDashboard from '../components/annualView/Summary/summary';
import AnnualTotalTable from '../components/annualView/annualTotalTable';
import { getAnnualTotalReport, getRemainingSummary } from '../utils/ActionCreator';

const AnnualView = () => {
  const [activeTab, setActiveTab] = useState('annual');
  const [remainingSummary,setRemainingSummary] = useState({});
  const [annualTotalReport,setAnnualTotalReport] = useState({});

  const fetchData=()=>{
    getRemainingSummary((callback)=>{
      setRemainingSummary(callback);
      fetchAnnualTotal()
    },(onErr)=>{
      setRemainingSummary({});
      fetchAnnualTotal();
    });
  }

  const fetchAnnualTotal = ()=>{
    getAnnualTotalReport((callback)=>{
      setAnnualTotalReport(callback);
    },(onErr)=>{
      setAnnualTotalReport({});
    });
  }



  useEffect(()=>{
    fetchData();
    
  },[]);

  return (
    <>
      <div style={AnnualViewTabsStyle.container}>
        <div style={AnnualViewTabsStyle.tabContainer}>
          <AnnualViewTabs activeTab={activeTab} setActiveTab={setActiveTab} />
          <div style={AnnualViewTabsStyle.contentContainer}>
            <div style={{
              ...AnnualViewTabsStyle.content,
              transform: `translateX(${activeTab === 'annual' ? '0%' : '-50%'})`
            }}>
              <div style={AnnualViewTabsStyle.panel}>
                <AnnualHeadStats remainingSummary={remainingSummary} />
                <AnnualTotalTable />
              </div>
              <div style={AnnualViewTabsStyle.panel}>
                {/* <AnnualHeadStats /> */}
                <FinancialDashboard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnualView;

